import { territoryAssignmentsSlice } from "./territoryAssignmentsSlice";
import * as actions from "./territoryAssignmentsActions";
import * as selectors from "./territoryAssignmentsSelectors";

export { actions };
export { selectors };
export default territoryAssignmentsSlice.reducer;
